module.exports = __webpack_public_path__ + "static/media/sdg2.9c3d6729.png";